module.exports = __webpack_public_path__ + "img/about-16.8b4d34d7.png";